import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "System Requirements",
  layout: {
    type: "customCase040102",
    options: {
      items: [
        {
          text: `Floor standing system <br> with a reasonable volume <br> (around 30 l)`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image01.svg`,
        },
        {
          text: `Bandwidth <br> as large as possible`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image02.svg`,
        },
        {
          text: `No need for high SPL`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image03.svg`,
        },
        {
          text: `Low cost (<200 €)`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image04.svg`,
        },
        {
          text: `Loudspeaker made of <br> 19 mm MDF: Easy to mill, <br> High density, Inexpensive`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image05.svg`,
        },
        {
          text: `Choice of cabinet:<br>Bass reflex to enhance <br>low frequency bandwidth`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image06.svg`,
        },
        {
          text: `Choice of the woofer: Audax HM170Z0 is a woofer-midrange a light and stiff aerogel diaphragm, Audax TW010F1 is known for having a good price/quality ratio`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image07.svg`,
        },
        {
          text: `Choice of filter: <br>First order filters will lower <br>the costs while giving <br>a good phase response`,
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide02-image08.svg`,
        },
      ],
      task: {
        items: [
          "Extend the frequency response towards the low frequencies",
          "Provide better isolation of the higher modes of the enclosure ",
          "Can improve the cooling of the coil",
          "Extend the frequency response towards the higher frequencies",
          "Can increase broadband efficiency by 10 dB",
          "Can lower the distortion around the tuning frequency",
        ],
        correctAnswers: [0, 2],
      },
    },
  },
};

export default principle;
